<app-summary-field [label]="label" *ngIf="partnerSummary"
                   iconName="user-circle" class="link">
    <div class="d-flex gap-5 align-items-center">
        <a (click)="redirectToPartner()">{{partnerSummary.name}}</a>
        <app-tags-summary-field *ngIf="partnerSummary.tagEntityType as tagEntityType" [entityType]="tagEntityType" [entityId]="partnerSummary.id"></app-tags-summary-field>
    </div>
</app-summary-field>
